import axiosClient from "./AxiosConfig";

const FieldDefinitionService = {

  async getAll() {
    return await axiosClient.get("/field/definitions");
  },

  async getById(id) {
    return await axiosClient.get(`/field/definitions/${id}`);
  },

  async create(fieldDefinition) {
    await axiosClient.post("/field/definitions", fieldDefinition);
  },

  async update(fieldDefinition) {
    return await axiosClient.put("/field/definitions", fieldDefinition);
  },

  async deleteById(id) {
    return await axiosClient.delete(`/field/definitions/${id}`);
  }
};

export default FieldDefinitionService;
